import { Injectable } from '@angular/core';
declare var dataLayer:any;
export interface GAGTMParams {
  pagetype: string | undefined;
  label: string;
}

@Injectable({
  providedIn: 'root'
})
export class DataLayerService {

  constructor() { }

  public onPageLoadGA(){
    dataLayer.push({
      'business_lob':'Bajaj Capital' ,
      'login_status':'Guest'
    })
  }

  public pushGAData(arg:any){
    dataLayer.push(arg)    
  }

  public GA_FieldInteraction(arg:any){
    dataLayer.push({
      'event':'field_interaction',
      'journey_status':arg.journey_status,
      'business_lob':'Bajaj Capital',
      'input_details':arg.field_name
      })
  }

  public leadformErrGA(){
    dataLayer.push({    
      'event':'lead_form_error',
      'business_lob':'Bajaj Capital',
      'journey_status':'Lead Form Stage'
    })
  }

  public rb_bio_arrow_click(params: GAGTMParams) {
    dataLayer.push({
      'event': 'rb_bio_arrow_click',
      'eventCategory': params.pagetype,
      'eventAction': 'rb_bio_arrow_click',
      'eventLabel': params.label
    });
  }
  public sb_bio_arrow_click(params: GAGTMParams) {
    dataLayer.push({
      'event': 'sb_bio_arrow_click',
      'eventCategory': params.pagetype,
      'eventAction': 'sb_bio_arrow_click',
      'eventLabel': params.label
    });
  }
}
